// Login.jsx
import React, { useState, useContext } from 'react';
import { authContext } from "../context/AuthContext";

import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';

import withStyles from '@mui/styles/withStyles';
import TextField from '@mui/material/TextField';
import { useHistory } from 'react-router';
import Autocomplete from '@mui/material/Autocomplete';
import {Button, Grid, Container } from '@mui/material';
import axios from 'axios';
import { withTranslation } from 'react-i18next';
import Alert from '@mui/material/Alert';


const { REACT_APP_GIBMP } = process.env;


const styles = theme => ({
    root: {
        '& .MuiTextField-root': {
            margin: '8px',
            width: '40ch',
            minWidth: '25ch',
            maxWidth: '90%'
        },
        '& .MuiButton-containedSecondary': {
            backgroundColor: 'white',
            color:'black'
        },
    },
});


//VIEW ISSUE: When view width decreases to right before XS size, the textfields overlap the other grid -> fix with min-width?
const Login = props => {
    const { classes } = props;
    const history = useHistory();

    //get user details from context
    const user = useContext(authContext)

    const [loginInfo, setLoginInfo] = useState({
        username: '',
        password: '',
    })

    const [email, setEmail] = useState('')
    const [users, setUsers] = useState([])
    const [numFound, setNumFound] = useState('')

    const {t} = props;

    const handleChange = (event) => {
        setLoginInfo({
            ...loginInfo,
            [event.target.name]: event.target.value
        });
    }

    const handleEmail = event => {
        setEmail(event.target.value)
    }

    const handleUserSelect = (name, value) => {
        // if value is null, set to empty string instead of null
        // otherwise only extract the username after -
        setLoginInfo({
            username: value ? value.split('- ')[1].trim() : '',
            password: '' //reset password to blank when select a user
        })
    }

    const searchUsers = async () => {
        const res = await axios.get("/api/user/search?email=" + email)
        const users = res.data.users.map(user => user.last_name + ', ' + user.first_name + ' - ' + user.username)
        setUsers(users)

        if (users.length === 0) setNumFound(t('LoginPage.NoUsersFoundEmail'))
        if (users.length === 1) {
            setNumFound(t('LoginPage.FoundOneUserEmail'))
            handleUserSelect(null, users[0]) // picks the first one if only one found
        }
        else setNumFound(t('LoginPage.Found') + ' ' + users.length + ' ' + t('LoginPage.UserAccountsEmailFound') )
    }

    const onSubmit = (event) => {
        event.preventDefault();
        user.login(loginInfo.username, loginInfo.password)
            .then(res => {
                //console.log('/user/' + loginInfo.username);
                let userTrack = sessionStorage.getItem('userTrack');
                
                if (userTrack === 'E')
                    history.push('/dashboard/employers/' + loginInfo.username);
                else if (userTrack === 'S')
                    history.push('/dashboard/trainingMain');
                 else if (userTrack === 'Z')
                    history.push('/zoomClass');
                else {
                    history.push('/dashboard');
                    
                }
                window.location.reload(false);
                   
            })
            .catch(err => {
                //do nothing since the error message is handled globally in the App.js
            });
    }

    const forgotPassword = () => {

        console.log('Forgot Password button clicked')
        // history.push('/forgotPassword')

        history.push({
            pathname : '/forgotPassword',
            state: { username : loginInfo.username || '' }
          })
    }


    return (
        <ValidatorForm noValidate onSubmit={onSubmit}>
            <div className={classes.root} style={{ textAlign: 'center' }} >
                            <Alert severity="info">{t('LoginPage.ResetPasswordMessage')}</Alert>

                <Container maxWidth="lg">
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <h4>{t('LoginPage.SignGIBMPAccount')}</h4>
                            <TextValidator
                                id="username"
                                label= {t('LoginPage.Username')}
                                type="text"
                                className={[].join(' ')}
                                onChange={handleChange}
                                value={loginInfo.username}
                                validators={['required']}
                                errorMessages={['username is required']}
                                name='username'
                                required
                            />

                            <TextValidator
                                id="password"
                                label={t('LoginPage.Passowrd')}
                                type="password"
                                className={[].join(' ')}
                                onChange={handleChange}
                                value={loginInfo.password}
                                validators={['required']}
                                errorMessages={['Password is required']}
                                name='password'
                                required
                            />

                            {/* <a href="/forgotPassword/" style={{ color: 'red' }}> {t('LoginPage.ForgotPassword')} </a> */}
                            <br />

                            <Grid container spacing = {3}
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                             >
                                
                                <Grid item >
                                     <Button variant="contained" style={{ whiteSpace: 'nowrap', width: 'fit-content' }} type="submit" color="primary" className="Button" > {t('LoginPage.SignIn')} </Button>
                                </Grid>
                             
                                <Grid item>
                                     <Button variant="outlined" style={{ whiteSpace: 'nowrap', width: 'fit-content' }} color="primary" onClick={forgotPassword} className="Button" >{t('LoginPage.ForgotPassword')} </Button>
                                </Grid>

                            </Grid>

                          
                            <br />
                            <br />
                            <h4> {t('LoginPage.NoAccount')} <a href="/user/"> {t('LoginPage.CreateGIBMPAccount')} </a></h4>
                            <h4>{t('LoginPage.HaveGatorLinkAccount')} <a  href={`${REACT_APP_GIBMP}/uflogin`}>{t('LoginPage.SignGatorLink')}</a></h4>

                            <br />
                            <br />

                        </Grid>

                        <Grid item xs={12} sm={6}>
                            {/* <h4>Forgot username?</h4> */}
                            {/* <p>Please enter your email to look for your username</p> */}
                            <h4>{t('LoginPage.EnterEmail')}</h4>
                            <p>{t('LoginPage.EnterEmailUsername')}</p>
                            <TextField
                                id="email"
                                label={t('LoginPage.EmailAddress')}
                                type="email"
                                className={[props.classes.textField].join(' ')}
                                onChange={handleEmail}
                                value={email} />

                            <br />
                            <br />

                            <Button onClick={searchUsers} variant="contained" style={{ whiteSpace: 'nowrap', width: 'fit-content' }} color="primary" className={[].join(' ')} > {t('LoginPage.Search')} </Button>

                            {/* <p style={{maxWidth: 345 }}>{numFound}</p> */}
                            <p >{numFound} </p>


                            <Autocomplete
                                //style={{ marginTop: 0 }}
                                id="users"
                                options={users}
                                onChange={handleUserSelect}
                                className={[props.classes.autoComplete].join(' ')}
                                autoHighlight
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={t('LoginPage.AvailableUsers')}
                                        className={[props.classes.textField].join(' ')}
                                        fullWidth
                                    />)}
                            />

                            <br />
                            <br />
                        </Grid>

                    </Grid>



                    {/* <br /><br /><br /> */}


                </Container>
            </div>
        </ValidatorForm >
    );
}

// export default (Login);
export default withStyles(styles, { withTheme: true })(withTranslation()(Login));